$(document).ready(() => {
    let mainBlogHandle = false;
  
    $(document).on('click', '[data-blog-filter-category-title]', function (e) {
      if (e.target.tagName.toLowerCase() === 'h4') {
        e.preventDefault();
  
        $(this).parents('.filter-option').toggleClass('open');
        $(this).next().animate({ height: 'toggle' });
      }
    });
  
    $(document).on('click', '[data-blog-filter-title]', function (e) {
      e.preventDefault();
  
      $(this).parents('.blog-filter').toggleClass('open');
      $(this).next().animate({ height: 'toggle' });
    });
  
    $(document).on('submit', '[data-blog-filter-form]', function (e) {
      e.preventDefault();
  
      const input = $('[data-blog-filter-form-input]').val();
      if (input) {
        window.location = `/blogs/${mainBlogHandle}?q=${input}`;
      }
    });
  
    function init() {
      const dataEl = $('[data-section-type="static-article-2"]');
      const data = JSON.parse(dataEl.data('section-data') || dataEl.html());
      console.log('Data========Articl=======>', data)
      mainBlogHandle = data.mainBlogHandle;
    }
  
    init();
  });